import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login'

import {USER_KEY, LOGIN_ROUTE} from '@/utils/consts'
import store from '@/store'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "system" */ '@/views/System.vue'),
    children: [
      // {
      //   path: '',
      //   name: 'home',
      //   component: Home
      // },
      {
        path: '',
        name: 'status',
        component: () => import(/* webpackChunkName: "status" */ '@/components/Status.vue'),
      },
      {
        path: '/callme',
        name: 'callme',
        component: () => import(/* webpackChunkName: "status" */ '@/components/Callme.vue'),
      },
      {
        path: '/settings',
        name: 'settings',
        component: () => import(/* webpackChunkName: "settings" */ '@/components/Settings.vue'),
      },
      {
        path: '/reports',
        name: 'reports',
        component: () => import(/* webpackChunkName: "reports" */ '@/components/Reports.vue'),
      },
      {
        path: '/agents',
        name: 'agents',
        component: () => import(/* webpackChunkName: "groups" */ '@/components/Agents.vue'),
      },
      {
        path: '/ddis',
        name: 'ddis',
        component: () => import(/* webpackChunkName: "ddis" */ '@/components/DDIs.vue'),
      },
      {
        path: '/groups',
        name: 'groups',
        component: () => import(/* webpackChunkName: "groups" */ '@/components/Groups.vue'),
      }
    ]
  },
  {
    path: '/login',
    name: LOGIN_ROUTE,
    component: Login,
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name != LOGIN_ROUTE) {
    if (localStorage.getItem(USER_KEY) == null) {
      next({name: LOGIN_ROUTE})
    }
  }

  if (to.name == 'logout') {
    store.dispatch('logout').then(() => next({name: LOGIN_ROUTE}))
  }

  next();
});

export default router
